import axios from "../axios-auth";
import orginal_axios from "axios";

export const procurementPlanAssetReportService = {
    getProcurementPlanAssetReport,
    procurementPlanAssetReportExcel,
};

function getProcurementPlanAssetReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy,
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }
    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.assetIds) {
        params["assetIds"] = searchParams.assetIds.join();
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }

    return axios.get("/auth/procurement-plan-asset-reports", { params });
}

function procurementPlanAssetReportExcel(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }
    if (searchParams.categoryName) {
        params["categoryName"] = searchParams.categoryName;
    }
    if (searchParams.brandName) {
        params["brandName"] = searchParams.brandName;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.assetIds) {
        params["assetIds"] = searchParams.assetIds.join();
    }
    if (searchParams.type) {
        params["type"] = searchParams.type;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/procurement-plan-asset-report-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
    }).then(function (response) {
        return {
            blob: new Blob([response.data], {
                type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            headers: response.headers,
        };
    });
}
